<template>
  <data-table
    :headers="headers"
    :items="placesWithCounts"
    :options.sync="options"
    :no-data-text="$t('no_data')"
    :loading="loading"
  >
    <template #item.name="{ item }">
      {{ item.name }}
    </template>
    <template #item.sensor_count="{ item }">
      {{ item.sensor_count }}
    </template>
    <template #item.timeline="{ item }">
      <router-link :to="timelineUrl(item)" v-if="hasSensors(item)">
        {{ $t('button.show') }}
      </router-link>
      <span class="floor-plans-link--disabled grey--text" v-else>
        {{ $t('button.show') }}
      </span>
    </template>
    <template #item.detection_trend="{ item }">
      <router-link :to="detectionTrendUrl(item)" v-if="hasSensors(item)">
        {{ $t('button.show') }}
      </router-link>
      <span class="floor-plans-link--disabled grey--text" v-else>
        {{ $t('button.show') }}
      </span>
    </template>
    <template #item.floor_plans="{ item }">
      <router-link :to="floorPlansUrl(item)" v-if="hasSensors(item)">
        {{ $t('button.show') }}
      </router-link>
      <span class="floor-plans-link--disabled" v-else>
        {{ $t('button.show') }}
      </span>
    </template>
    <template #item.actions="{ item }">
      <v-btn
        icon
        @click="$emit('edit', item)"
        data-testid="edit_button"
      >
        <v-icon class="ma-2 material-icons">edit</v-icon>
      </v-btn>
      <v-btn
        icon
        @click="$emit('delete', item)"
        data-testid="delete_button"
      >
        <v-icon class="ma-2 material-icons">delete</v-icon>
      </v-btn>
    </template>
  </data-table>
</template>

<i18n lang="yaml">
ja:
  column:
    name: 管理施設名
    sensor_count: センサー数
    timeline: タイムライン
    detection_trend: 検出数推移
    floor_plans: 図面
  button:
    show: 表示する
  no_data: 管理施設がありません
en:
  column:
    name: Facility name
    sensor_count: Sensors
    timeline: Timeline
    detection_trend: Detection Trend
    floor_plans: Floor Plans
  button:
    show: Show
  no_data: No facilities available
</i18n>

<script>
import DataTable from '@/components/atoms/DataTable';

export default {
  name: 'r-type-place-table',
  components: {
    DataTable,
  },
  props: {
    places: {
      type: Array,
      required: true,
    },
    sensors: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 20,
      },
    };
  },
  computed: {
    sensorIdSet() {
      return new Set(this.sensors.map(s => s.id));
    },
    placesWithCounts() {
      return this.places.map(place => ({
        ...place,
        sensor_count: place.entity_ids.filter(id => this.sensorIdSet.has(id)).length,
      }));
    },
    headers() {
      const h = [
        { text: this.$t('column.name'), value: 'name', cellClass: 'name-column' },
        { text: this.$mpt(this.$t('column.sensor_count')), value: 'sensor_count', width: 120 },
        { text: this.$t('column.timeline'), value: 'timeline', sortable: false, width: 120 },
      ];
      h.push({
        text: this.$t('column.detection_trend'),
        value: 'detection_trend',
        sortable: false,
        width: 120,
      });
      h.push({
        text: this.$t('column.floor_plans'),
        value: 'floor_plans',
        sortable: false,
        width: 120,
      });
      h.push({ text: '', value: 'actions', sortable: false, width: 110 });
      return h;
    },
  },
  methods: {
    hasSensors(item) {
      return item.sensor_count > 0;
    },
    timelineUrl(item) {
      return `/r_type_places/${encodeURI(item.id)}/timeline`;
    },
    detectionTrendUrl(item) {
      return `/r_type_places/${encodeURI(item.id)}/detection_trend`;
    },
    floorPlansUrl(item) {
      return `/r_type_places/${encodeURI(item.id)}/floor_plans`;
    },
  },
};
</script>

<style scoped lang="sass">
::v-deep .name-column
  overflow-wrap: anywhere

.floor-plans-link--disabled
  color: #bdbdbd
</style>
